<template>
<div class="UserIncomesetting">
</div>
</template>

<script>
export default {
    name: 'UserIncomesetting',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.UserIncomesetting {
}
</style>
